/* Search dock (2026-10-14, Stefan: „the search bar should be sticky in this section, and also in blog"). A fixed strip that
   docks under the site header once the page's own search field has scrolled out through the top of the viewport and
   undocks when the field is back. Every search is handed to that field (its value + requestSubmit), so each page keeps its
   own search logic — the search page runs its in-place results (the hero is off screen, so its player skips the dive), the
   blog its article results. The strip sits under the on-scroll-up sticky header whenever the header is on screen. */
(() => {
  const dock = document.querySelector('[data-ips-dock]');
  if (!dock || dock.dataset.ready) return;
  dock.dataset.ready = '1';
  const src = document.querySelector(dock.dataset.source || '');
  const srcInput = src ? src.querySelector('input[name="q"]') : null;
  if (!src || !srcInput) return;
  const form = dock.querySelector('form');
  const input = form.querySelector('input[name="q"]');
  const header = document.querySelector('#ip-pdp-nav, .ip-pdp-nav, .section-header, .header-wrapper');   // the site's sticky bar
  let on = false;
  let top = -1;
  const bg = dock.querySelector('.ipsd-bg');
  const pagescan = document.querySelector('.ipsd-pagescan');
  const vv = window.visualViewport;
  const phone = window.matchMedia('(max-width: 900px)');
  const stillOnly = window.matchMedia('(prefers-reduced-motion: reduce)');
  const loop = (v) => {   // the bacteria loop behind the bar: loaded on the first dock, slow, paused while undocked
    if (!bg || stillOnly.matches) return;
    if (v) {
      const k = phone.matches ? 'mobile' : 'desktop';
      if (bg.dataset.loaded !== k) { bg.dataset.loaded = k; bg.poster = bg.dataset[k + 'Poster'] || bg.poster; bg.src = bg.dataset[k + 'Src']; }
      bg.playbackRate = 0.6;
      const p = bg.play(); if (p && p.catch) p.catch(() => {});
    } else bg.pause();
  };
  const setTop = () => {   // sit under the site header whenever any of it is on screen (sticky bar, or a header that returns on scroll up)
    let t = 0;
    if (header) { const r = header.getBoundingClientRect(); if (r.height > 0 && r.bottom > 0 && r.top <= 1) t = Math.max(0, Math.round(r.bottom)); }
    if (t !== top) { top = t; document.documentElement.style.setProperty('--ipsd-top', t + 'px'); }
    document.documentElement.style.setProperty('--ipsd-h', dock.offsetHeight + 'px');
  };
  const check = () => { show(src.getBoundingClientRect().bottom < 0); };   // the page's field has left through the top → docked
  const show = (v) => {
    if (v === on) return;
    on = v;
    if (v) { input.value = srcInput.value; setTop(); }
    dock.classList.toggle('is-on', v);
    dock.setAttribute('aria-hidden', v ? 'false' : 'true');
    loop(v);
    if (phone.matches) {
      if (v && pagescan && !stillOnly.matches) { pagescan.classList.remove('is-run'); void pagescan.offsetWidth; pagescan.classList.add('is-run'); }   // the scan sweeps the page, the bar rises behind it
      if (!v) dock.style.bottom = '';
    }
    document.documentElement.classList.toggle('ips-docked', v);
  };
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { show(!e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 }).observe(src);
  }
  let ticking = false;
  window.addEventListener('scroll', () => {   // the scroll path decides too, so docking never waits on the observer
    if (ticking) return;
    ticking = true;
    check();   // synchronous: docking never waits on a frame
    window.requestAnimationFrame(() => { ticking = false; if (on) setTop(); });
  }, { passive: true });
  window.addEventListener('resize', () => { check(); setTop(); });
  const lift = () => {   // phones: the keyboard (visual viewport) lifts the bottom bar above itself
    if (!on || !phone.matches || !vv) return;
    const gap = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    dock.style.bottom = gap ? gap + 'px' : '';
  };
  if (vv) { vv.addEventListener('resize', lift); vv.addEventListener('scroll', lift); }
  check();
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const term = input.value.trim();
    if (!term) { input.focus(); return; }
    srcInput.value = term;
    input.blur();
    src.dataset.ipsFromDock = '1';   // the page's handler may skip its hero animation for a search made from the dock
    if (typeof src.requestSubmit === 'function') src.requestSubmit();
    else src.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });
  srcInput.addEventListener('input', () => { if (!on) input.value = srcInput.value; });
})();
